<template lang="pug">
el-container.layout
  .logo(@click="redirectToCloud")
    img(alt="Logo", src="img/logo.png")
  .login-layout
    div(v-show="display.loginForm")
      h1 登 录
      h5 没有账号，
        el-button.link-button(type="text", @click="switchForm('signupForm')") 快速注册
      el-form.login-form(
        status-icon,
        :model="loginForm",
        :rules="loginRules",
        ref="loginForm"
      )
        el-form-item(prop="name")
          el-input(
            v-model="loginForm.name",
            prefix-icon="el-icon-user",
            placeholder="请输入账号名"
          )
        el-form-item(prop="password")
          el-input(
            type="password",
            v-model="loginForm.password",
            autocomplete="off",
            prefix-icon="el-icon-key",
            placeholder="请输入账号密码",
            @keyup.enter.native="submitForm('loginForm')"
          )
        el-form-item
          el-button.confirm-button(@click="submitForm('loginForm')") 登 录
        el-form-item
          el-button.switch-button(
            type="text",
            @click="switchForm('phoneLoginForm')"
          ) 手机登录
    div(v-show="display.phoneLoginForm")
      h1 登 录
      h5 没有账号，
        el-button.link-button(type="text", @click="switchForm('signupForm')") 快速注册
      el-form.login-form(
        status-icon,
        :model="phoneLoginForm",
        :rules="phoneLoginRules",
        ref="phoneLoginForm"
      )
        el-form-item(prop="phoneNumber")
          el-input(
            v-model="phoneLoginForm.phoneNumber",
            prefix-icon="el-icon-mobile-phone",
            placeholder="请输入关联手机号"
          )
        el-form-item(prop="code")
          el-input(
            v-model="phoneLoginForm.code",
            autocomplete="off",
            prefix-icon="el-icon-key",
            placeholder="请输入验证码",
            @keyup.enter.native="submitForm('phoneLoginForm')"
          )
            el-button(
              slot="append",
              @click="createPhoneCode",
              :disabled="phoneCodeBtn.disabled"
            ) {{ phoneCodeBtnText }}
        el-form-item
          el-button.confirm-button(@click="submitForm('phoneLoginForm')") 登 录
        el-form-item
          el-button.switch-button(
            type="text",
            @click="switchForm('loginForm')"
          ) 密码登录
    div(v-show="display.signupForm")
      h1 注 册
      h5 已有账号，
        el-button.link-button(type="text", @click="switchForm('loginForm')") 快速登录
      el-form.signup-form(
        status-icon,
        :model="signupForm",
        :rules="signupRules",
        ref="signupForm"
      )
        el-form-item(prop="name")
          el-input(
            v-model="signupForm.name",
            prefix-icon="el-icon-user",
            placeholder="请输入账号名"
          )
        el-form-item(prop="password")
          el-input(
            type="password",
            v-model="signupForm.password",
            autocomplete="off",
            prefix-icon="el-icon-key",
            placeholder="请输入账号密码"
          )
        el-form-item(prop="confirmPass")
          el-input(
            type="password",
            v-model="signupForm.confirmPass",
            autocomplete="off",
            prefix-icon="el-icon-key",
            placeholder="请确认账号密码",
            @keyup.enter.native="submitForm('signupForm')"
          )
        el-form-item
          el-button.confirm-button(@click="submitForm('signupForm')") 注 册
  el-footer
    p Copyrigh©2020 上海蔚星数据科技有限公司 All rights reserved
    p
      a.icp(href="https://beian.miit.gov.cn/") 沪ICP备16011377号
</template>

<script>
import docCookies from "@/utils/docCookies.js"
import { signup, login, generateSmsCodeAPI } from "@/services"
const defaultLoginForm = {
  name: "",
  password: ""
}
const defaultPhoneLoginForm = {
  phoneNumber: "",
  code: ""
}
const defaultSignUpForm = {
  name: "",
  password: "",
  confirmPass: ""
}
const defaultPhoneCodeBtn = {
  disabled: false,
  countDown: 0
}
export default {
  name: "Login",
  props: ["internalUrl", "externalUrl"],
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!/^(\w+)$/.test(value)) {
        callback(new Error("用户名只能包含大小写英文字母、数字和下划线"))
      } else if (value.length < 3) {
        callback(new Error("用户名字符不得少于3个"))
      } else {
        callback()
      }
    }
    const validatePassSecure = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"))
      } else if (value.length < 8) {
        callback(new Error("密码长度过短"))
      } else if (value.length > 64) {
        callback(new Error("密码长度过长"))
      } else {
        if (this.signupForm.confirmPass !== "") {
          this.$refs.signupForm.validateField("confirmPass")
        }
        callback()
      }
    }
    const validatePassConfirm = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.signupForm.password) {
        callback(new Error("两次输入密码不一致"))
      } else {
        callback()
      }
    }
    const validatePhoneNumber = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号码格式错误"))
      } else {
        callback()
      }
    }
    return {
      display: {
        loginForm: true,
        phoneLoginForm: false,
        signupForm: false
      },
      phoneCodeBtn: Object.assign({}, defaultPhoneCodeBtn),
      loginForm: Object.assign({}, defaultLoginForm),
      phoneLoginForm: Object.assign({}, defaultPhoneLoginForm),
      signupForm: Object.assign({}, defaultSignUpForm),
      loginRules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      },
      phoneLoginRules: {
        phoneNumber: [
          {
            required: true,
            validator: validatePhoneNumber,
            trigger: ["blur"]
          }
        ],
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: ["blur"]
          }
        ]
      },
      signupRules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          },
          {
            required: true,
            validator: validateUsername,
            trigger: "change"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassSecure,
            trigger: "blur"
          }
        ],
        confirmPass: [
          {
            required: true,
            validator: validatePassConfirm,
            trigger: "change"
          }
        ]
      }
    }
  },
  methods: {
    /**
     * Backend Service API Func Wrapper
     */
    async login(data) {
      this.loading = true
      try {
        const res = await login(data)
        if (res.status === 201) {
          docCookies.setItem(
            "vsat-iam",
            String(res.data.token),
            null,
            "/",
            window.location.host.split(".").slice(-2).join(".")
          )
          Object.assign(localStorage, {
            account: res.data.name,
            type: res.data.accountType,
            org: res.data.org,
            orgRole: res.data.orgRole
          })
          !this.externalUrl
            ? this.$router.push({path: this.internalUrl || "/"})
            : window.location.assign(this.externalUrl)
        }
      } catch (err) {
        this.$message.error("登录失败，请确认用户名和密码")
      } finally {
        this.loading = false
      }
    },
    async signup() {
      this.loading = true
      try {
        const res = await signup(this.signupForm)
        if (res.status === 201) {
          this.$message.success("用户注册成功，欢迎登陆使用")
          this.display.loginForm = true
          this.display.signupForm = false
        }
        this.signupForm = {
          name: "",
          password: "",
          confirmPass: ""
        }
      } catch (err) {
        if (!err.response.body.message) {
          this.$message.error("用户注册失败")
        } else {
          this.$message.error(err.response.body.message)
        }
      } finally {
        this.loading = false
      }
    },
    async createPhoneCode() {
      this.loading = true
      try {
        const res = await generateSmsCodeAPI(
          this._.pickBy(this.phoneLoginForm, this._.identity)
        )
        if (res.status === 201) {
          this.$message.success("短信验证码已发送，请查收")
          this.phoneCodeBtn.countDown = 60
        }
      } catch (err) {
        if (err.status === 404) {
          this.$message.warning("手机号未绑定蔚星云账号")
        } else {
          this.$message.error("服务器开小差了，请尝试重新操作")
        }
      } finally {
        this.loading = false
        this.countDownTimer()
      }
    },
    /**
     * UI Control
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === "loginForm") {
            this.login(this.loginForm)
          } else if (formName === "phoneLoginForm") {
            this.login(this.phoneLoginForm)
          } else if (formName === "signupForm") {
            this.signup()
          }
        } else {
          this.$message.error("输入不合规范，请检查后再尝试")
          return false
        }
      })
    },
    switchForm(formName) {
      this.display = this._.mapValues(this.display, () => false)
      this.display[formName] = true
      this.$refs[formName].resetFields()
    },
    countDownTimer() {
      if (this.phoneCodeBtn.countDown > 0) {
        setTimeout(() => {
          this.phoneCodeBtn.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    redirectToCloud() {
      window.open("https://vsat.cloud", "_self")
    }
  },
  watch: {
    "phoneCodeBtn.countDown": {
      handler(val) {
        if (val) {
          this.phoneCodeBtn.disabled = true
        } else {
          this.phoneCodeBtn.disabled = false
        }
      },
      immediate: true
    }
  },
  computed: {
    phoneCodeBtnText: function() {
      if (this.phoneCodeBtn.countDown === 0) {
        return "获取验证码"
      } else {
        return `${this.phoneCodeBtn.countDown}s后重新获取`
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.layout {
  overflow: hidden;
  height: 100%;
  background: url('/img/login-bg.jpg') no-repeat center center;
  background-size: cover;
}

.logo {
  width: 120px;
  height: 67px;
  position: absolute;
  left: 100px;
  top: 35px;

  &:hover {
    cursor: pointer;
  }

  img {
    width: 120px;
  }
}

.login-layout {
  margin: 180px auto;
  width: 320px;
  height: 410px;
  background: #ffffff;
  border-radius: 4px;

  h1 {
    margin: 40px auto -15px 120px;
    color: #46464B;
    font-size: 35px;
  }

  h5 {
    margin: 10px 0 0 170px;
    color: #46464B;
    font-size: 14px;
  }
}

.login-form {
  width: 280px;
  height: 410px;
  margin: 0 auto;
  padding: 0 20px;

  .el-form-item {
    &:last-child {
      text-align: center;
      margin-top: -20px;
    }
  }
}

.signup-form {
  width: 280px;
  height: 410px;
  margin: 0 auto;
  padding: 0 20px;
}

.confirm-button {
  width: -webkit-fill-available;
  background: #19A2B6;
  color: #ffffff;
  font-size: 20px;
}

.switch-button {
  width: -webkit-fill-available;
  color: #19A2B6;
  font-size: 16px;
}

.link-button {
  font-size: 14px;
  color: #19A2B6;
}

.el-footer {
  width: 100%;
  color: #fff;
  text-align: center;
  font-size: small;
  position: absolute;
  bottom: 0px;
}

.icp {
  color: #fff;
  text-decoration: none;
}
</style>
